import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  SHOW_ANNOUNCEMENT_BAR: '',
  CLOSE_ANNOUNCEMENT_BAR: '',


  SHOW_URGENT_ANNOUNCEMENT_BAR: '',
  CLOSE_URGENT_ANNOUNCEMENT_BAR: ''

};

types = setStoreTypeValues(types, 'appAnnouncements');

export default types;
